import React from 'react'
import PropTypes from 'prop-types'
import cssModules from 'react-css-modules'
import { getI18n } from 'client/i18n'
import DateTextBox from 'components/common/date_text_box'
import EditForm from '../edit_form'
import styles from './edit_end_date.less'
import { formatDateShort } from 'client/griffin'
import { Link } from 'react-router'
import { glimpseRoute } from 'lib/route_utils'

const i18n = getI18n('components/edit_glimpse/edit_end_date')

class EditEndDate extends React.Component {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    title: PropTypes.string,
    fields: PropTypes.object.isRequired,
    ended: PropTypes.bool,
    endable: PropTypes.bool,
    endDate: PropTypes.instanceOf(Date),
    onEndNow: PropTypes.func,
  }

  render() {
    const {
      fields: { endDate },
    } = this.props
    return (
      <EditForm {...this.props}>
        <div styleName="title" role="heading" aria-level="1">
          {i18n('title')}
        </div>
        {this.props.ended &&
          this.props.endDate && (
            <div>
              <div styleName="ended-title">
                {i18n('ended', {
                  endDate: formatDateShort(this.props.endDate),
                })}
              </div>
              <div styleName="ended-description">
                {i18n('ended_description')}
              </div>
            </div>
          )}
        <DateTextBox
          {...endDate}
          data-pa-focus="endDate"
          title={i18n('end_date')}
          autoFocus={true}
        />
        <div styleName="description">{i18n('description')}</div>
        <button
          data-pa-click="save"
          data-nemo="save"
          className="vx_btn vx_btn-block"
          styleName="save-button"
        >
          {i18n('save')}
        </button>
        {this.props.endable && (
          <Link
            data-pa-click="endPool"
            className="vx_btn vx_btn-block vx_btn-secondary"
            styleName="end-now-button"
            to={glimpseRoute('edit', 'end')}
          >
            {i18n('end_now')}
          </Link>
        )}
      </EditForm>
    )
  }
}

export default cssModules(EditEndDate, styles)
